import store from '../config/redux-store';
import Roles from '../common/constants/roles';

abstract class PermissionService {
  static getUserRole() {
    const {
      user: { current: user },
    } = store.getState();

    return user.data?.role || Roles.ROLE_UNKNOWN;
  }

  static hasRoles(requiredRoles: Roles[]) {
    const userRole = this.getUserRole();
    if (requiredRoles.indexOf(userRole) > -1) {
      return true;
    }

    return false;
  }
}

export default PermissionService;
